export const EVENT_FILTER_WHEN_IS_PAST = 'brightness(70%)';
